export enum OfferingVariants {
  None = 'None',
  SimBindingAgreement = 'SimBindingAgreement',
}
